import type { TaxedPrice } from "../TaxedPrice.js";
import { calculatePriceWithTax } from "./calculatePriceWithTax.js";
import { calculatePriceWithoutTax } from "./calculatePriceWithoutTax.js";

/** Either of the prices is calculated from the other one, so they're never given both. */
export type TaxedPriceInput =
	| { taxRate: number; withoutTax: number; withTax?: never }
	| { taxRate: number; withTax: number; withoutTax?: never };

export function taxedPrice(price: TaxedPriceInput): TaxedPrice {
	if (price.withoutTax !== undefined) {
		return { ...price, withTax: calculatePriceWithTax(price.withoutTax, price.taxRate) };
	}
	return { ...price, withoutTax: calculatePriceWithoutTax(price.withTax, price.taxRate) };
}
